/**
 * AI Agent Service Implementation
 */
import { IAIAgentService, AIAgentRequest, AIAgentResponse } from '../interfaces/IAIAgentService';
import { unifiedApi } from '../UnifiedApiService';

export class AIAgentService implements IAIAgentService {
  private apiUrl: string;

  constructor(apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  async processRequest(request: AIAgentRequest): Promise<AIAgentResponse> {
    try {
      const response = await unifiedApi.post<AIAgentResponse>('/ai/agent/process/', request);
      return response;
    } catch (error) {
      console.error('AI Agent process error:', error);
      return {
        success: false,
        error: 'Failed to process request'
      };
    }
  }

  async executeActionPlan(actionPlan: any, churchId: string, userId: string): Promise<any> {
    try {
      const response = await unifiedApi.post('/ai/agent/execute/', {
        action_plan: actionPlan,
        church_id: churchId,
        user_id: userId
      });
      return response;
    } catch (error) {
      console.error('AI Agent execute error:', error);
      return {
        success: false,
        error: 'Failed to execute action'
      };
    }
  }

  async getActionHistory(filters?: {
    status?: string;
    action_type?: string;
    days?: number;
  }): Promise<any[]> {
    try {
      const params = new URLSearchParams();
      if (filters?.status) params.append('status', filters.status);
      if (filters?.action_type) params.append('action_type', filters.action_type);
      if (filters?.days) params.append('days', filters.days.toString());
      
      const response = await unifiedApi.get<any[]>(`/ai/agent/history/?${params.toString()}`);
      return response;
    } catch (error) {
      console.error('Failed to get action history:', error);
      return [];
    }
  }

  async getActionStats(params: { days: number }): Promise<any> {
    try {
      const response = await unifiedApi.get<any>('/ai/agent/history/stats/', { params });
      return response;
    } catch (error) {
      console.error('Failed to get action stats:', error);
      return {};
    }
  }

  async getSuggestions(context: any): Promise<any[]> {
    try {
      const response = await unifiedApi.get<{ suggestions: any[] }>('/ai/agent/suggestions/', { params: context });
      return response.suggestions || [];
    } catch (error) {
      console.error('Failed to get suggestions:', error);
      return [];
    }
  }
}